// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2541":"97175455","2661":"47a9ced2","4689":"a66ace7c","4989":"cb527e8a","6710":"22af6dfb","7031":"2e27cd69","7777":"f6fc7f4a","7852":"6ac7be56","8056":"ee35a42a","8653":"63e71372","8765":"ee35a42a","9665":"ccb0b99e"}[chunkId] + ".chunk.css";
};